// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1116) return "static/chunks/1116-850c7ed0e158fb62.js";
	if (chunkId === 8743) return "static/chunks/8743-5e25dce609bda94c.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"501":"d72417b80aaa29c3","2931":"1d3afd6fd06bac47","4199":"8f634536c4efbfce","4316":"890f6f4190c9fdfb"}[chunkId] + ".js";
};